import React from "react";
import "@assets/scss/intel.scss";
import "@assets/scss/global.scss";
import { Filter } from "react-feather";
export default class EmptyFilter extends React.Component {
  render() {
    return (
      <div className="empty-fillter-container">
        <Filter size={20} color="#1C59DE" />
        <p>{!!this.props.content && this.props.content !== "" ? this.props.content : "No matching filters found for this search"}</p>
      </div>
    );
  }
}
